import Immutable from "seamless-immutable";

const initialState = Immutable({});

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default Reducer;
